import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Card,
  Typography,
  Input,
  Modal,
  Form,
  notification,
  Spin,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  CameraOutlined,
  EnvironmentFilled,
} from "@ant-design/icons";
import moment from "moment";
import { Storage } from "aws-amplify";
import { getDetails, update } from "../../api/Apis";
import MapComponent from "./MapComponent";
import deliveryTruck from "../../Images/delivered.png";
import AppConfigs from "../../Config/AppConfig";
import { noWhitespaceRule } from "../../utils/Utils";
import GeneratePdf from "../../Components/GeneratePdf";
import Docsample from "../../Images/pdf.jpg";

const { Text } = Typography;

function beforeUpload(file) {
  const isJpgOrPng =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "application/pdf";
  if (!isJpgOrPng) {
    notification["error"]({
      message: "You can only upload JPG/PNG file!",
    });
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    notification["error"]({
      message: "Image must smaller than 2MB!",
    });
  }
  return isJpgOrPng && isLt2M;
}

class DriverDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoading: false,
      pickedUpModel: false,
      deliveryModel: false,
      driverLeadDetails: "",
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      imageUrl4: "",
      delImage: "",
      delTicket: "",
      uploadPicLoading1: false,
      uploadPicLoading2: false,
      uploadPicLoading3: false,
      uploadPicLoading4: false,
      grossWeight: 0,
      teraWeight: 0,
      dataLoadingStatus: false,
    };
  }

  componentDidMount() {
    this.getDriverLeadDetails();
  }

  getDriverLeadDetails = async () => {
    this.setState({
      dataLoading: true,
    });
    getDetails("orders", this.props.match.params.id).then(async (result) => {
      if (result.success) {
        let deliveryImage = "";
        let deliveryTicket = "";
        if (result.data["leadDeliveryImage"]) {
          if (result.data["leadDeliveryImage"]?.delivery_pic !== "") {
            deliveryImage = await Storage.get(
              result.data["leadDeliveryImage"]?.delivery_pic
            );
          }
          if (result.data["leadDeliveryImage"]?.delivery_ticket_pic !== "") {
            deliveryTicket = await Storage.get(
              result.data["leadDeliveryImage"]?.delivery_ticket_pic
            );
          }
        }
        this.setState({
          driverLeadDetails: result.data,
          dataLoading: false,
          delImage: deliveryImage,
          delTicket: deliveryTicket,
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  };

  updateStatus = async (status) => {
    this.setState({
      dataLoading: true,
    });
    let data = {
      entityData: {
        orderStatus: status,
        recordId: this.props.match.params.id,
        typeofPage: "orderDetails",
      },
    };

    update("orders", this.props.match.params.id, data).then((result) => {
      if (result.success) {
        this.resetValues();
        this.getDriverLeadDetails();
        notification["success"]({
          message: "Status changed successfully",
        });
      } else {
        console.log(result.errors);
        this.resetValues();
        notification["error"]({
          message: "Something went wrong",
        });
      }
    });
  };

  loadDelivered = (e) => {
    const { imageUrl1, imageUrl2, imageUrl3, delImage, delTicket } = this.state;
    this.setState({
      dataLoading: true,
    });

    let deliveryImagesList = {
      driver_sign: imageUrl1,
      customer_sign: imageUrl2,
      delivery_ticket_pic: delTicket,
      delivery_pic: delImage,
    };
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (imageUrl3?.length === 0) {
          notification["error"]({
            message: "Please Upload Written Ticket image",
          });
        } else {
          let data = {
            entityData: {
              deliveryDateAndTime:
                moment(new Date()).format("MM/DD/YYYY") +
                " " +
                moment(new Date()).format("hh:mm A"),
              leadDeliveryImage: deliveryImagesList,
              orderStatus: "D",
              ticketNumber: values["tNumber"],
              weight: {
                grossWeight: values.grossWeight,
                tareWeight: values.tareWeight,
                netWeight:
                  parseFloat(values.grossWeight - values.tareWeight) / 2000,
              },
              recordId: this.props.match.params.id,
              typeofPage: "orderDetails",
            },
          };
          await update("orders", this.props.match.params.id, data).then(
            (result) => {
              if (result.success) {
                this.resetValues();
                this.getDriverLeadDetails();
                notification["success"]({
                  message: "Status changed successfully",
                });
              } else {
                console.log(result.errors);
                this.resetValues();
                notification["error"]({
                  message: "Something went wrong",
                });
              }
            }
          );
        }
      }
    });
  };
  handleUploadPic = async (fileData, imageType) => {
    if (imageType === "_driver_sign_") {
      this.setState({
        uploadPicLoading1: true,
      });
    } else if (imageType === "_customer_sign_") {
      this.setState({
        uploadPicLoading2: true,
      });
    } else if (imageType === "_delivery_ticket_pic_") {
      this.setState({
        uploadPicLoading3: true,
      });
    } else {
      this.setState({
        uploadPicLoading4: true,
      });
    }

    let file = fileData["file"]["originFileObj"];
    let fileName =
      this.state.driverLeadDetails["subOrderId"] + imageType + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then(async (result) => {
      let deliveryImage = "";
      let deliveryTicket = "";
      if (imageType === "_driver_sign_") {
        this.setState({
          imageUrl1: result.key,
          uploadPicLoading1: false,
        });
      } else if (imageType === "_customer_sign_") {
        this.setState({
          imageUrl2: result.key,
          uploadPicLoading2: false,
        });
      } else if (imageType === "_delivery_ticket_pic_") {
        deliveryTicket = await Storage.get(result.key);
        this.setState({
          imageUrl3: deliveryTicket,
          uploadPicLoading3: false,
          delTicket: result.key,
        });
      } else {
        deliveryImage = await Storage.get(result.key);
        this.setState({
          imageUrl4: deliveryImage,
          uploadPicLoading4: false,
          delImage: result.key,
        });
      }
    });
  };

  resetValues = () => {
    this.setState({
      dataLoading: false,
      pickedUpModel: false,
      deliveryModel: false,
    });
  };

  fileDownload = async (fileName) => {
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  render() {
    const {
      pickedUpModel,
      deliveryModel,
      driverLeadDetails,
      imageUrl1,
      imageUrl2,
      imageUrl3,
      imageUrl4,
      grossWeight,
      teraWeight,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      driverLeadDetails && (
        <div>
          <Spin spinning={this.state.dataLoadingStatus}>
            <Row className="driverDetails-body">
              <Col span={24} className="driverDetails-back">
                <Col xl={4} lg={4} md={4} sm={9} xs={9} className="back-arrow">
                  <Link onClick={() => this.props.history.goBack()}>
                    <span style={{ color: "black", fontSize: "16px" }}>
                      <ArrowLeftOutlined
                        style={{ fontSize: "1em", marginRight: "5px" }}
                      />
                      Back
                    </span>
                  </Link>
                </Col>
                <Col xl={{ span: 18 }} lg={20} md={20} sm={12} xs={12}>
                  <Col
                    style={{
                      cursor: "pointer",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                    xl={{ span: 6, offset: 13 }}
                    className="show-on-desktop"
                  >
                    <GeneratePdf
                      leadData={driverLeadDetails}
                      callFrom="orders"
                      pathName="orderDetails"
                      startLoading={() =>
                        this.setState({ dataLoadingStatus: true })
                      }
                      stopLoading={() =>
                        this.setState({ dataLoadingStatus: false })
                      }
                    />
                  </Col>
                  <Col xl={{ span: 4, offset: 1 }}>
                    <Button
                      className="btn-picked"
                      onClick={() => {
                        driverLeadDetails.orderStatus === "I" ||
                        driverLeadDetails.orderStatus === "AC"
                          ? this.updateStatus("PS")
                          : driverLeadDetails.orderStatus === "PS"
                          ? this.setState({ pickedUpModel: true })
                          : driverLeadDetails.orderStatus === "PU"
                          ? this.setState({ deliveryModel: true })
                          : console.log("completed");
                      }}
                      style={{
                        float: "right",
                        fontSize: "16px",
                        fontWeight: "bold",
                        backgroundColor:
                          driverLeadDetails.orderStatus === "I" ||
                          driverLeadDetails.orderStatus === "AC"
                            ? "#0e4d90"
                            : driverLeadDetails.orderStatus === "PS"
                            ? " #0e4d90"
                            : driverLeadDetails.orderStatus === "PU"
                            ? "#FF6C5E"
                            : "#9DADBC",
                      }}
                    >
                      {driverLeadDetails.orderStatus === "I" ||
                      driverLeadDetails.orderStatus === "AC"
                        ? AppConfigs["DISPLAY_LEAD_STATUS"]["driver"]["I"]
                        : driverLeadDetails.orderStatus === "PS"
                        ? AppConfigs["DISPLAY_LEAD_STATUS"]["driver"][
                            driverLeadDetails.orderStatus
                          ]
                        : driverLeadDetails.orderStatus === "PU"
                        ? AppConfigs["DISPLAY_LEAD_STATUS"]["driver"][
                            driverLeadDetails.orderStatus
                          ]
                        : "Completed"}
                    </Button>
                  </Col>
                </Col>
              </Col>

              <Col
                xl={6}
                lg={7}
                md={24}
                sm={24}
                xs={24}
                style={{ marginRight: "2vw" }}
              >
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="col-margin-bottom"
                >
                  <div className="site-card-border-less-wrapper">
                    <Card
                      title="Product Details"
                      style={{ borderRadius: "10px" }}
                    >
                      <Row>
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">Order Id</Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {driverLeadDetails.orderId}
                          </Text>
                        </Col>
                      </Row>

                      <Row className="row-marginTop">
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">Product Name</Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {driverLeadDetails.productName}
                          </Text>
                        </Col>
                      </Row>

                      <Row className="row-marginTop">
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">Product Size</Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {driverLeadDetails.size}
                          </Text>
                        </Col>
                      </Row>
                    </Card>
                  </div>
                </Col>

                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="col-margin-bottom"
                >
                  <div className="site-card-border-less-wrapper">
                    <Card title="Load Details" style={{ borderRadius: "10px" }}>
                      <Row>
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">
                            Pickup Location Timings
                          </Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {driverLeadDetails.pickupDate + ","}
                            {Array.isArray(
                              driverLeadDetails.productOriginDetails
                            )
                              ? driverLeadDetails.productOriginDetails?.[0]
                                  ?.loadingTimes
                              : driverLeadDetails.productOriginDetails
                                  ?.loadingTimes}
                          </Text>
                        </Col>
                      </Row>

                      <Row className="row-marginTop">
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">
                            Preferred Delivery Date & Time
                          </Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {/* {driverLeadDetails.estimatedDeliveryDate +
                            "," +
                            driverLeadDetails.estimatedDeliveryTime} */}
                            {driverLeadDetails.deliveryReqDate +
                              "," +
                              driverLeadDetails.deliveryReqTime}
                          </Text>
                        </Col>
                      </Row>

                      <Row className="row-marginTop">
                        <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                          <Text className="text-title">
                            Delivery Location Timings
                          </Text>
                        </Col>
                        <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                          <Text className="text-Description">
                            {driverLeadDetails.pickupDate +
                              "," +
                              driverLeadDetails.pickupStartTime +
                              "-" +
                              driverLeadDetails.pickupEndTime}
                          </Text>
                        </Col>
                      </Row>
                    </Card>
                  </div>
                </Col>

                {driverLeadDetails.productOriginDetails &&
                  driverLeadDetails.productOriginDetails.materialsLoaded && (
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="col-margin-bottom"
                    >
                      <div className="site-card-border-less-wrapper">
                        <Card
                          title="Material Details"
                          style={{ borderRadius: "10px" }}
                        >
                          <Row>
                            <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                              <Text className="text-title">
                                Measurement Type
                              </Text>
                            </Col>
                            <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                              <Text className="text-Description">
                                {driverLeadDetails.measurementType}
                              </Text>
                            </Col>
                          </Row>

                          <Row className="row-marginTop">
                            <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                              <Text className="text-title">
                                Materials Loaded
                              </Text>
                            </Col>
                            <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                              <Text className="text-Description">
                                {driverLeadDetails.productOriginDetails.materialsLoaded.join(
                                  ", "
                                )}
                              </Text>
                            </Col>
                          </Row>
                          <Row className="row-marginTop">
                            <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                              <Text className="text-title">Quantity</Text>
                            </Col>
                            <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                              <Text className="text-Description">
                                {driverLeadDetails.quantity}
                              </Text>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  )}
              </Col>

              {driverLeadDetails.customerLatLng && (
                <Col xl={17} lg={16} md={24} sm={24} xs={24}>
                  <div className="site-card-border-less-wrapper">
                    <Card style={{ borderRadius: "10px" }}>
                      <MapComponent
                        lat={driverLeadDetails.customerLatLng.lat}
                        lng={driverLeadDetails.customerLatLng.lng}
                        isMarkerShown
                      />
                      <Row style={{ marginTop: "2vw" }}>
                        <Col span={24}>
                          <h3>
                            <EnvironmentFilled style={{ color: "#0971E0" }} />{" "}
                            {driverLeadDetails.address}
                          </h3>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            marginLeft: "6px",
                            marginTop: "-18px",
                            marginBottom: "-16px",
                          }}
                        >
                          <h2>|</h2>
                        </Col>
                        <Col span={24}>
                          <h3>
                            <EnvironmentFilled style={{ color: "#FF6C5E" }} />{" "}
                            {driverLeadDetails.productOriginDetails.address}
                          </h3>
                        </Col>
                      </Row>
                    </Card>
                  </div>

                  <Card style={{ borderRadius: "10px", marginTop: "1vw" }}>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="col-margin-bottom"
                    >
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Row className="row-marginTop">
                          <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                            <Text className="text-title">Distance (Miles)</Text>
                          </Col>
                          <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                            <Text className="text-Description">
                              {driverLeadDetails.distanceMiles}
                            </Text>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Row className="row-marginTop">
                          <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                            <Text className="text-title">Carrier Name</Text>
                          </Col>
                          <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                            <Text className="text-Description">
                              {driverLeadDetails.carrierDetails &&
                                driverLeadDetails.carrierDetails.carrierName}
                            </Text>
                          </Col>
                        </Row>
                      </Col>
                    </Col>
                  </Card>

                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    className="col-margin-bottom row-marginTop"
                  >
                    {driverLeadDetails.driverDetails && (
                      <Col lg={11} md={24} sm={24} xs={24}>
                        <div className="site-card-border-less-wrapper">
                          <Card
                            title="Driver Details"
                            style={{ borderRadius: "10px" }}
                          >
                            <Row>
                              <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                                <Text className="text-title">Driver Name</Text>
                              </Col>
                              <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                                <Text className="text-Description">
                                  {driverLeadDetails.driverDetails.name}
                                </Text>
                              </Col>
                            </Row>
                            <Row className="row-marginTop">
                              <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                                <Text className="text-title">Driver Phone</Text>
                              </Col>
                              <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                                <Text className="text-Description">
                                  {driverLeadDetails.driverDetails.phone}
                                </Text>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    )}

                    {driverLeadDetails.truckDetails && (
                      <Col lg={{ span: 11, offset: 2 }} md={24} sm={24} xs={24}>
                        <div className="site-card-border-less-wrapper">
                          <Card
                            title="Truck Details"
                            style={{ borderRadius: "10px" }}
                          >
                            <Row>
                              <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                                <Text className="text-title">
                                  Type of Truck
                                </Text>
                              </Col>
                              <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                                <Text className="text-Description">
                                  {driverLeadDetails.truckDetails.typeOfTruck}
                                </Text>
                              </Col>
                            </Row>
                            <Row className="row-marginTop">
                              <Col xl={14} lg={14} md={14} sm={14} xs={24}>
                                <Text className="text-title">Truck Number</Text>
                              </Col>
                              <Col xl={10} lg={10} md={10} sm={10} xs={24}>
                                <Text className="text-Description">
                                  {driverLeadDetails.truckDetails.truckNumber}
                                </Text>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    )}
                  </Col>
                  {driverLeadDetails.notes && (
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="col-margin-bottom"
                    >
                      <div className="site-card-border-less-wrapper">
                        <Card
                          title="Notes"
                          style={{ borderRadius: "10px", marginTop: "1vw" }}
                        >
                          <Text className="text-Description">
                            {driverLeadDetails.notes}
                          </Text>
                        </Card>
                      </div>
                    </Col>
                  )}
                  {driverLeadDetails.orderStatus === "D" &&
                    driverLeadDetails.leadDeliveryImage && (
                      <Col
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        className="col-margin-bottom"
                      >
                        <div className="site-card-border-less-wrapper">
                          <Card
                            title="Delivered Images"
                            style={{ borderRadius: "10px", marginTop: "1vw" }}
                          >
                            {driverLeadDetails.leadDeliveryImage
                              .customer_sign && (
                              <Col span={6}>
                                <Text
                                  className="text-Description"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  Customer sign
                                </Text>
                                <img
                                  src={
                                    driverLeadDetails.leadDeliveryImage
                                      .customer_sign &&
                                    driverLeadDetails.leadDeliveryImage.customer_sign.includes(
                                      ".pdf"
                                    )
                                      ? Docsample
                                      : `https://${
                                          process.env.REACT_APP_S3_BUCKET
                                        }.s3.amazonaws.com/public/${encodeURIComponent(
                                          driverLeadDetails.leadDeliveryImage
                                            .customer_sign
                                        )}`
                                  }
                                  alt="avatar"
                                  style={{
                                    width: "14vw",
                                    height: "14vw",
                                    marginTop: "0.5vw",
                                  }}
                                />
                              </Col>
                            )}
                            {driverLeadDetails.leadDeliveryImage
                              .driver_sign && (
                              <Col span={6}>
                                <Text
                                  className="text-Description"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  Driver sign
                                </Text>
                                <img
                                  src={
                                    driverLeadDetails.leadDeliveryImage
                                      .driver_sign &&
                                    driverLeadDetails.leadDeliveryImage.driver_sign.includes(
                                      ".pdf"
                                    )
                                      ? Docsample
                                      : `https://${
                                          process.env.REACT_APP_S3_BUCKET
                                        }.s3.amazonaws.com/public/${encodeURIComponent(
                                          driverLeadDetails.leadDeliveryImage
                                            .driver_sign
                                        )}`
                                  }
                                  alt="avatar"
                                  style={{
                                    width: "14vw",
                                    height: "14vw",
                                    marginTop: "0.5vw",
                                  }}
                                />
                              </Col>
                            )}
                            {driverLeadDetails.leadDeliveryImage
                              .delivery_ticket_pic && (
                              <Col span={6}>
                                <Text
                                  className="text-Description"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  Delivery ticket
                                </Text>
                                <img
                                  src={
                                    this.state.delTicket &&
                                    this.state.delTicket.includes(".pdf")
                                      ? Docsample
                                      : this.state.delTicket
                                  }
                                  alt="avatar"
                                  style={{
                                    width: "14vw",
                                    height: "14vw",
                                    marginTop: "0.5vw",
                                  }}
                                />
                              </Col>
                            )}
                            {driverLeadDetails.leadDeliveryImage
                              .delivery_pic && (
                              <Col span={6}>
                                <Text
                                  className="text-Description"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  Delivery pic
                                </Text>
                                <img
                                  src={
                                    this.state.delImage &&
                                    this.state.delImage.includes(".pdf")
                                      ? Docsample
                                      : this.state.delImage
                                  }
                                  alt="avatar"
                                  style={{
                                    width: "14vw",
                                    height: "14vw",
                                    marginTop: "0.5vw",
                                  }}
                                />
                              </Col>
                            )}
                          </Card>
                        </div>
                      </Col>
                    )}
                </Col>
              )}
            </Row>
          </Spin>
          <Modal
            className="modal-black-close"
            visible={pickedUpModel}
            closable={true}
            onCancel={() =>
              this.setState({
                pickedUpModel: false,
              })
            }
            footer={null}
            width={
              window.screen.width >= "1600"
                ? "20%"
                : window.screen.width > "1599" && window.screen.width <= "1280"
                ? "25%"
                : window.screen.width > "1279" && window.screen.width <= "1024"
                ? "35%"
                : "80%"
            }
          >
            <div>
              <Row>
                <div style={{ textAlign: "center" }}>
                  <img src={deliveryTruck} alt="" />
                  <p
                    style={{
                      color: "#2F4858",
                      marginTop: "10px",
                      fontSize: "18px",
                    }}
                  >
                    Confirm Pick-up
                  </p>
                  <p
                    style={{
                      color: " #9DADBC",
                      marginTop: "10px",
                      fontSize: "14px",
                    }}
                  >
                    Have you arrived at your pick-up address?
                  </p>
                  <Button
                    className="cancel-btn-modal"
                    onClick={() =>
                      this.setState({
                        pickedUpModel: false,
                      })
                    }
                  >
                    Not Yet
                  </Button>
                  <Button
                    className="Yes-btn-modal"
                    onClick={() => this.updateStatus("PU")}
                  >
                    Yes
                  </Button>
                </div>
              </Row>
            </div>
          </Modal>

          <Modal
            title="Delivery Confirmation"
            className="modal-black-close"
            visible={deliveryModel}
            onCancel={() =>
              this.setState({
                deliveryModel: false,
              })
            }
            footer={null}
            style={{ marginTop: "1vw" }}
            width={
              window.screen.width >= "1600"
                ? "50%"
                : window.screen.width > "1024" && window.screen.width <= "1599"
                ? "60%"
                : "90%"
            }
          >
            {driverLeadDetails && (
              <Form>
                <div style={{ marginLeft: "2vw" }}>
                  <Row>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {/* xl={{ span: 11 }}
                      lg={{ span: 11 }}
                      md={{ span: 11 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    > */}
                      <Form.Item
                        label={
                          <span className="text-modal">Delivery Date</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.estimatedDeliveryDate}
                          readOnly
                        />
                      </Form.Item>
                    </Col>

                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        label={
                          <span className="text-modal">Delivery Time</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.estimatedDeliveryTime}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* <Row>
                    <Col
                      xl={{ span: 11 }}
                      lg={{ span: 11 }}
                      md={{ span: 11 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Customer Name</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.customerName}
                          readOnly
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xl={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={<span className="text-modal">Carrier Name</span>}
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.carrierDetails.carrierName}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  {/* <Row>
                    <Col
                      xl={{ span: 23 }}
                      lg={{ span: 23 }}
                      md={{ span: 23 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Delivery Location</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.address}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  {/* <Row>
                    <Col
                      xl={{ span: 11 }}
                      lg={{ span: 11 }}
                      md={{ span: 11 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={<span className="text-modal">Product Name</span>}
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.productName}
                          readOnly
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xl={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Material Size</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.size}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  <Row>
                    {/* <Col
                      xl={{ span: 11 }}
                      lg={{ span: 11 }}
                      md={{ span: 11 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Truck Plate Number</span>
                        }
                        className="form-item-mobile"
                      >
                        <Input
                          className="driver-modal-date"
                          value={driverLeadDetails.truckDetails.truckNumber}
                          readOnly
                        />
                      </Form.Item>
                    </Col> */}

                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={<span className="label">Ticket Number</span>}
                      >
                        {getFieldDecorator("tNumber", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Ticket Number!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={11} md={11} sm={24} xs={24}>
                      <Form.Item
                        label={<span className="label">Gross Weight</span>}
                        className="Formitem"
                      >
                        {getFieldDecorator("grossWeight", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Gross Weight!",
                            },
                          ],
                        })(
                          <Input
                            // className="driver-modal-date"
                            onChange={(event) => {
                              this.setState({
                                grossWeight: event.target.value,
                              });
                            }}
                            // value=""
                            // readOnly
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col
                      lg={{ span: 11, offset: 2 }}
                      md={{ span: 11, offset: 2 }}
                      sm={24}
                      xs={24}
                    >
                      <Form.Item
                        label={<span className="text-modal">Tare Weight</span>}
                        className="form-item-mobile"
                      >
                        {getFieldDecorator("tareWeight", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Tare Weight!",
                            },
                          ],
                        })(
                          <Input
                            // className="driver-modal-date"
                            onChange={(event) => {
                              this.setState({ teraWeight: event.target.value });
                            }}
                            // value=""
                            // readOnly
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    {/* <Col
                      xl={{ span: 6 }}
                      lg={{ span: 12 }}
                      md={{ span: 12 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Driver Signature</span>
                        }
                        className="form-item-mobile"
                      >
                        <Spin spinning={this.state.uploadPicLoading1}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_driver_sign_")
                            }
                          >
                            {imageUrl1 ? (
                              <img
                                src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${imageUrl1}`}
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon" />
                            )}
                          </Upload>
                        </Spin>
                      </Form.Item>
                    </Col> */}

                    {/* <Col
                      xl={{ span: 6 }}
                      lg={{ span: 12 }}
                      md={{ span: 12 }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Customer Signature</span>
                        }
                        className="form-item-mobile"
                      >
                        <Spin spinning={this.state.uploadPicLoading2}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_customer_sign_")
                            }
                            spinning={this.state.uploadPicLoading}
                          >
                            {imageUrl2 ? (
                              <img
                                src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/${imageUrl2}`}
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon" />
                            )}
                          </Upload>
                        </Spin>
                      </Form.Item>
                    </Col> */}

                    <Col lg={11} md={11} sm={24} xs={24}>
                      <Form.Item
                        label={
                          <span className="text-modal">
                            Delivery Ticket Image
                          </span>
                        }
                        className="form-item-mobile"
                      >
                        <Spin spinning={this.state.uploadPicLoading3}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_ticket_pic_")
                            }
                          >
                            {imageUrl3 ? (
                              <img
                                src={
                                  imageUrl3 && imageUrl3.includes(".pdf")
                                    ? Docsample
                                    : imageUrl3
                                }
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon" />
                            )}
                          </Upload>
                        </Spin>
                      </Form.Item>
                    </Col>

                    <Col
                      lg={{ span: 11, offset: 2 }}
                      md={{ span: 11, offset: 2 }}
                      sm={24}
                      xs={24}
                    >
                      <Form.Item
                        label={
                          <span className="text-modal">Delivery Image</span>
                        }
                        className="form-item-mobile"
                      >
                        <Spin spinning={this.state.uploadPicLoading4}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                              width: "100%",
                              height: "100%",
                            }}
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_pic_")
                            }
                          >
                            {imageUrl4 ? (
                              <img
                                src={
                                  imageUrl4 && imageUrl4.includes(".pdf")
                                    ? Docsample
                                    : imageUrl4
                                }
                                alt="avatar"
                                style={{ width: "100px", height: "100%" }}
                              />
                            ) : (
                              <CameraOutlined className="camera-icon" />
                            )}
                          </Upload>
                        </Spin>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="row-margin-bottom">
                    <Col xl={{ span: 11, offset: 12 }}>
                      <Col span={8} offset={7}>
                        <Button
                          className="cancel-btn"
                          onClick={() => {
                            this.setState({
                              deliveryModel: false,
                              grossWeight: 0,
                              teraWeight: 0,
                            });
                            this.props.form.setFieldsValue({
                              grossWeight: "",
                              tareWeight: "",
                            });
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col span={8} offset={1}>
                        <Button
                          form="form"
                          className="submit-btn"
                          htmlType="submit"
                          onClick={this.loadDelivered}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Col>
                  </Row>
                </div>
              </Form>
            )}
          </Modal>
        </div>
      )
    );
  }
}

export default Form.create({ name: "CarrierDetails" })(DriverDetails);
